import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import * as toastr from 'toastr';
import {ContractualValuesService} from '../service-contractual-values/contractual-values.service';
import {LocalCustomerModel} from '../../../../models/LocalCustomerModel';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {ContractTypeModel} from '../../../../models/ContractTypeModel';
import {ContractualDataModel} from '../../../../models/ContractualDataModel';
import {ResourcesUnitModel} from '../../../../models/ResourcesUnitModel';
import {NumAnnoMeseService} from '../../../general-services/service-num-anno-mese/num-anno-mese.service';
import { MatTableDataSource } from '@angular/material/table';
import {ChargingMethodologyService} from '../../../general-services/service-charging-methodology/charging-methodology.service';
import {ProviderModel} from '../../../../models/ProviderModel';
import {BaseGeneralComponent} from '../../../BaseGeneralComponent';

export interface NumAnnoMese {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-new-contractual-data',
  templateUrl: './new-contractual-values.component.html',
  styleUrls: ['./new-contractual-values.component.scss']
})
export class NewContractualValuesComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  showActions: boolean;

  contractualData: ContractualDataModel;
  localCustomerSelect: LocalCustomerModel;
  contractTypeSelect: ContractTypeModel;
  resourceUnitSelect: ResourcesUnitModel;
  providerSelect: ProviderModel;

  getPageSubscribe: Subscription;
  saveContractualData: Subscription;
  getAllChargingMethodologySubscribe: Subscription;

  allMonth: any;
  allCharging: any;
  listData: MatTableDataSource<any>;

  showLC: boolean;
  showType: boolean;
  showResourceUnit: boolean;
  showProvider: boolean;
  resetPriceRange: boolean;
  enablePriceRange: boolean;
  enablePXQ: boolean;
  enableArcRrc: boolean;
  enableFixed: boolean;
  registerForm: FormGroup;
  submitted = false;

  constructor(private route: ActivatedRoute, private router: Router,
              private contractualDataService: ContractualValuesService,
              private formBuilder: FormBuilder,
              private loaderService: LoaderService,
              private annoMeseService: NumAnnoMeseService,
              private chargingMethodologyService: ChargingMethodologyService) {
    super();
    this.showActions = false;
    this.showLC  = false;
    this.resetPriceRange = false;
    this.contractualData = new ContractualDataModel();
    this.localCustomerSelect = new LocalCustomerModel();
    this.contractTypeSelect = new ContractTypeModel();
    this.resourceUnitSelect = new ResourcesUnitModel();
    this.providerSelect = new ProviderModel();

    this.hideAllTable();
  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      anno: [{value: '', disabled: false}, Validators.required],
      provider: [{value: '', disabled: false}, Validators.required],
      localCustomerCod: [{value: '', disabled: false}, Validators.required],
      contractType: [{value: '', disabled: false}, Validators.required],
      resourceUnit: [{value: '', disabled: false}, Validators.required],
      chargingMethodology: [{value: '', disabled: false}, Validators.required],
      bmc: [{value: '', disabled: false}, Validators.required],
      bmv: [{value: '', disabled: false}, Validators.required],
      arc: [{value: '', disabled: false}, Validators.required],
      rrc: [{value: '', disabled: false}, Validators.required],
      pxq: [{value: '', disabled: false}, Validators.required]
    });
    this.getAllMonth();
    this.getAllChargingMethodology();
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 0}});
  }

  save() {
    this.submitted = true;
    if (this.registerForm.valid) {
      event.preventDefault();
      this.updateFieldValues();
      this.loaderService.display(true);
      this.saveContractualData = this.contractualDataService.save(this.contractualDataService.baseUrl, this.contractualData)
        .subscribe(
          (result: any) => {
            if (result === -1) {
              toastr.options.timeout = 5000;
              toastr.warning('Duplicate item, cannot be created', 'Warning');
              this.loaderService.display(false);
            } else {
              toastr.success('Contractual Value was created with success', 'Success');
              this.loaderService.display(false);
              this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 0}});
            }
          },
          error => {
            toastr.error('Contractual Value was not created', 'Error');
            this.loaderService.display(false);
          });
    }
  }

  updateFieldValues() {
    this.contractualData.bmc = this.registerForm.value.bmc;
    this.contractualData.bmv = this.registerForm.value.bmv;
    this.contractualData.arc = this.registerForm.value.arc;
    this.contractualData.rrc = this.registerForm.value.rrc;
    this.contractualData.pxq = this.registerForm.value.pxq;
  }

  getAllMonth() {
    this.getPageSubscribe = this.annoMeseService.getAllMonth(this.providerSelect)
      .subscribe(
        (result: any) => {
          this.allMonth = result;
        });
  }

  getAllChargingMethodology() {
    this.getAllChargingMethodologySubscribe = this.chargingMethodologyService.getAll(this.chargingMethodologyService.baseUrl, null)
      .subscribe(
        (result: any) => {
          this.allCharging = result;
        }
      );
  }

  ngOnDestroy(): void {
    if (this.saveContractualData) {
      this.saveContractualData.unsubscribe();
    }
  }

  getElementSelectedLC($event) {
    this.contractualData.localCustomer = $event.row;
    this.localCustomerSelect = $event.row;
    this.registerForm.patchValue({
      localCustomerCod: this.localCustomerSelect.cod
    });
  }

  getElementSelectedContractType($event) {
    this.contractualData.contractType = $event.row;
    this.contractTypeSelect = $event.row;
    this.registerForm.patchValue({
      contractType: this.contractTypeSelect.cod
    });
  }

  getElementSelectedResourceUnit($event) {
    this.contractualData.resourceUnit = $event.row;
    this.resourceUnitSelect = $event.row;
    this.registerForm.patchValue({
      resourceUnit: this.resourceUnitSelect.cod
    });
  }

  getElementSelectedProvider($event) {
    this.contractualData.provider = $event.row;
    this.providerSelect = $event.row;
    this.registerForm.patchValue({
      provider: this.providerSelect.cod
    });
  }

  getElementSelectRangeList($event) {
    this.contractualData.priceRangeList = $event.priceList;
  }

  toggleLC() {
    this.showLC = !this.showLC;
  }

  toggleContractType() {
    this.showType = !this.showType;
  }

  toggleResourceUnitCod() {
    this.showResourceUnit = !this.showResourceUnit;
  }

  toggleProvider() {
    this.showProvider = !this.showProvider;
  }

  handleMonth(element) {
    this.contractualData.numAnnoMese = element;
  }

  handleCharging(chargingMethSelected: string) {
    this.contractualData.chargingMethodology = chargingMethSelected;
    this.contractualData.priceRangeList = [];
    this.enablePriceRange = this.contractualData.chargingMethodology === this.CHARGING_METHODOLOGY.PRICE_RANGE;
    this.enablePXQ = this.contractualData.chargingMethodology === this.CHARGING_METHODOLOGY.PXQ;
    this.enableArcRrc = this.contractualData.chargingMethodology === this.CHARGING_METHODOLOGY.ARC_RRC;
    this.enableFixed = this.contractualData.chargingMethodology === this.CHARGING_METHODOLOGY.FIXED;
    this.contractualData.bmc = this.registerForm.value.bmc;
    this.contractualData.bmv = this.registerForm.value.bmv;
    this.contractualData.arc = 0;
    this.contractualData.rrc = 0;

    if (this.enablePriceRange) {
      this.contractualData.bmc = 0;
      this.contractualData.bmv = 0;
      this.contractualData.pxq = 0;
      this.registerForm.patchValue({arc: this.contractualData.arc});
      this.registerForm.patchValue({bmc: this.contractualData.bmc});
      this.registerForm.patchValue({bmv: this.contractualData.bmv});
      this.registerForm.patchValue({rrc: this.contractualData.rrc});
      this.registerForm.patchValue({pxq: this.contractualData.pxq});
    }

    if (this.enablePXQ) {
      this.contractualData.pxq = this.registerForm.value.pxq;
      this.registerForm.patchValue({arc: this.contractualData.arc});
      this.registerForm.patchValue({rrc: this.contractualData.rrc});
    }

    if (this.enableArcRrc) {
      this.contractualData.pxq = 0;
      this.contractualData.arc = this.registerForm.value.arc;
      this.contractualData.rrc = this.registerForm.value.rrc;
      this.registerForm.patchValue({pxq: this.contractualData.pxq});
    }

    if (this.enableFixed) {
      this.contractualData.pxq = 0;
      this.registerForm.patchValue({pxq: this.contractualData.pxq});
      this.registerForm.patchValue({arc: this.contractualData.arc});
      this.registerForm.patchValue({rrc: this.contractualData.rrc});
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }

  hideAllTable() {
    this.showLC = false;
    this.showResourceUnit = false;
    this.showType = false;
    this.showProvider = false;
  }

  reset() {
    this.resetPriceRange = !this.resetPriceRange;
    this.resetLc();
    this.resetResourceUnitCod();
    this.resetContractType();
    this.resetProvider();
    this.hideAllTable();
  }

  resetLc() {
    this.registerForm.patchValue({
      localCustomerCod: ''
    });
    this.showLC = false;
    this.localCustomerSelect = null;
  }

  resetContractType() {
    this.registerForm.patchValue({
      contractType: ''
    });
    this.showType = false;
    this.contractTypeSelect = null;
  }

  resetResourceUnitCod() {
    this.registerForm.patchValue({
      resourceUnit: ''
    });
    this.showResourceUnit = false;
    this.resourceUnitSelect = null;
  }

  resetProvider() {
    this.registerForm.patchValue({
      providerCod: ''
    });
    this.showProvider = false;
    this.providerSelect = null;
  }


  checkRangeListValid() {
    if (this.contractualData.priceRangeList.length > 0) {
      const lastIndexPriceRange = this.contractualData.priceRangeList.length - 1;
      return this.contractualData.priceRangeList[lastIndexPriceRange].volMax === null;
    }
    return true;
  }
}
